import View from "@ckeditor/ckeditor5-ui/src/view"
export default class OptionItemView extends View {
  /**
   * @inheritDoc
   */
  constructor(locale) {
    super(locale)

    /**
     * Collection of the child views inside of the list item {@link #element}.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
    this.children = this.createCollection()

    this.setTemplate({
      tag: "option",

      attributes: {
        class: ["ck", "ck-list__item"],
      },
      children: this.children,
    })
  }

  /**
   * Focuses the list item.
   */
  focus() {
    this.children.first.focus()
  }
}
